import * as actions from './actions';
import { ReduxUtils } from '@dw/pwa-helpers/redux-utils';

const initialState = {
  aiText: {
    status: 'INIT',
    text: null,
    error: null
  }
};

export default function cardReducer(state = initialState, action) {
  let oState = {...state};
  const cardId = action.cardId;
  const error = action.error;
  
  switch (action.type) {
    case actions.GENERATE_AI_TEXT:
      oState = ReduxUtils.replace(oState, `aiText.${cardId}.status`, 'IN_PROGRESS');
      oState = ReduxUtils.replace(oState, `aiText.${cardId}.text`, null);
      return ReduxUtils.replace(oState, `aiText.${cardId}.error`, null);

    case actions.GENERATE_AI_TEXT_SUCCESS:
      oState = ReduxUtils.replace(oState, `aiText.${cardId}.status`, 'SUCCESS');
      oState = ReduxUtils.replace(oState, `aiText.${cardId}.text`, action.text);
      return ReduxUtils.replace(oState, `aiText.${cardId}.error`, null);

    case actions.GENERATE_AI_TEXT_FAILURE:
      oState = ReduxUtils.replace(oState, `aiText.${cardId}.status`, 'FAILED');
      oState = ReduxUtils.replace(oState, `aiText.${cardId}.text`, null);
      return ReduxUtils.replace(oState, `aiText.${cardId}.error`, error);
    case actions.AI_ASSISTANCE_DIALOG_CLOSED:
      return initialState;
    default:
      return state;
  }
}